import M from 'backbone.marionette'
import T from './punchListItem.html'
import Radio from 'backbone.radio';
import moment from 'moment'
import { minutesToTimeString } from '../../utils/utils';

export const PunchListitem = M.View.extend({
    template: _.template(T),
    tagName: 'li',
    className: 'list-group-item',
    serializeData: function(){
        const momentOpts = {
                lastDay : '[hier]',
                sameDay : '[aujourd\'hui]',
                nextDay : '[demain]',
                lastWeek : 'dddd [dernier]',
                nextWeek : 'dddd',
                sameElse : 'L'
            }
        return _.extend( 
            this.model.toJSON(), 
            {
                totalString: minutesToTimeString(this.model.get('total')),
                showName: this.getOption('showName'),
                user: this.getOption('user').toJSON(),
                formattedValidateDate: this.model.get('validateDate') ? moment(this.model.get('validateDate')).calendar(null, momentOpts) : null,
                formattedTraitee: this.model.get('tratee') ? moment(this.model.get('tratee')).calendar(null, momentOpts) : null,
            } 
        )
    },
    events: {
        'click button.btValider':'onValiderClick'
    },
    modelEvents:{
        'change':'render',
    },
    onValiderClick: function(){
        if(this.getOption('user').get('admin') === true){
            if(confirm('Valider ce punch ?')){
                Radio.channel('punch').trigger('validate', this.model);
            }
        }
    }
})